import {createStore, applyMiddleware, combineReducers} from 'redux';
import thunk from 'redux-thunk'
import LoginReducer from './authentication/reducers/LoginReducer';
import ForgotPasswordReducer from './authentication/reducers/ForgotPasswordReducer';
import setAppSettingsReducer from './authentication/reducers/SetAppSettingsReducer';
import FeedReducer from './Appointments/reducers/FeedReducer';
import TaskReducer from './Appointments/reducers/TaskReducer';
import PartnerReducer from './Appointments/reducers/PartnerReducer';
import CustomerProfileReducer from "./profile/reducers/CustomerProfileReducer";
import VerifyAddressReducer from './Appointments/reducers/VerifyAddressReducer';
import CreateAppointmentReducer from './Appointments/reducers/CreateAppointmentReducer';
import activeLocale from './Translations/reducers/activeLocale';
import loadingTranslations from './Translations/reducers/loadingTranslations';
import translations from './Translations/reducers/translations';
/**
 * Configuration of store
 */
const ConfigureStore = () => {
  const rootReducer = combineReducers({
    login: LoginReducer,
    forgotPassword: ForgotPasswordReducer,
    setAppSettings: setAppSettingsReducer,
    feed: FeedReducer,
    tasks_bare_minimum: TaskReducer,
    partners: PartnerReducer,
    customer:CustomerProfileReducer,
    verifyAddress: VerifyAddressReducer,
    createAppointment: CreateAppointmentReducer,
    activeLocale,
    loadingTranslations,
    translations
  });
  return createStore(rootReducer, applyMiddleware(thunk));
};

export default ConfigureStore;
